import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import {
  getTrackingConsent,
  hasStoredTrackingConsent,
  setTrackingConsent,
} from "../lib/trackingConsent";

function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(!hasStoredTrackingConsent());
  const [consentGranted, setConsentGranted] = useState(getTrackingConsent());

  useEffect(() => {
    const handleOpen = () => {
      setVisible(true);
    };

    const handleConsentChanged = (event) => {
      setConsentGranted(Boolean(event?.detail?.granted));
      setVisible(false);
    };

    window.addEventListener("proshare:open-tracking-consent", handleOpen);
    window.addEventListener("proshare:tracking-consent-changed", handleConsentChanged);

    return () => {
      window.removeEventListener("proshare:open-tracking-consent", handleOpen);
      window.removeEventListener("proshare:tracking-consent-changed", handleConsentChanged);
    };
  }, []);

  const handleChoice = (granted) => {
    setConsentGranted(granted);
    setTrackingConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-4xl rounded-3xl border border-slate-200 bg-white/95 p-5 shadow-[0_24px_80px_rgba(15,23,42,0.18)] backdrop-blur">
      <button
        type="button"
        onClick={() => setVisible(false)}
        className="absolute right-3 top-3 inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 transition hover:border-slate-300 hover:text-slate-700"
        aria-label="Close tracking preferences banner"
      >
        <FiX className="text-lg" />
      </button>
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sky-700">
            Privacy Controls
          </p>
          <p className="text-base font-semibold text-slate-900">Tracking preferences</p>
          <p className="max-w-2xl text-sm leading-6 text-slate-600">
            ProShare can use Google Analytics and, if later enabled for launch, consent-gated
            session insights to understand navigation, product views, and conversion flows. These
            non-essential trackers stay off unless you allow them.
          </p>
          <p className="text-xs font-medium text-slate-500">
            Current setting: {consentGranted ? "analytics allowed" : "analytics rejected"}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => handleChoice(false)}
            className="inline-flex min-w-[140px] items-center justify-center rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={() => handleChoice(true)}
            className="inline-flex min-w-[160px] items-center justify-center rounded-xl bg-sky-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-700"
          >
            Allow analytics
          </button>
        </div>
      </div>
    </div>
  );
}

export default AnalyticsConsentBanner;
